import React, { useState } from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Radio from "@mui/material/Radio";
import Divider from "@mui/material/Divider";
import FormControlLabel from "@mui/material/FormControlLabel";
import SelectAllIcon from "@mui/icons-material/SelectAll";
import PageviewOutlinedIcon from "@mui/icons-material/PageviewOutlined";
import AppsIcon from "@mui/icons-material/Apps";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
import AddAssetsModal from "./AddAssetsModal";
import useQuery from "../../../hooks/useQuery";
import useRoles from "../../../hooks/user/useRoles";

const PAGINATION_PAGES = [24, 48, 72, 96];

export default function SettingsButton({
  pagination,
  onChange,
  assets,
  processNewItem,
}) {
  const query = useQuery();
  const isGuest = useRoles(["guest"]);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const inventoryRequestId =
    query.get("inventoryRequestId") || query.get("orderPicking") || query.get("id");
  const isInventoryRequest = !!inventoryRequestId;

  const handleLimitChange = value => {
    onChange({ limit: value });
  };

  const handleSelectAllChange = popupState => {
    setSelectAllChecked(true);
    popupState.close();
  };

  return (
    <PopupState variant="popover" popupId="settings-menu">
      {popupState => (
        <>
          <IconButton
            {...bindTrigger(popupState)}
            sx={{
              border: "1px solid",
              borderColor: "divider",
              borderRadius: "20px",
              width: 40,
              height: 40,
              "&:hover": {
                borderColor: "text.secondary",
              },
            }}
          >
            <AppsIcon />
          </IconButton>
          <Menu
            {...bindMenu(popupState)}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            sx={{ mt: 0.5 }}
            PaperProps={{ sx: { width: 280 } }}
          >
            {!isGuest && (
              <MenuItem onClick={() => handleSelectAllChange(popupState)}>
                <SelectAllIcon sx={{ mr: 2, color: "text.secondary" }} />
                <Typography>Select Entire Page</Typography>
              </MenuItem>
            )}
            {assets.length > 0 && (
              <>
                {!isGuest && <Divider />}
                <PopupState variant="popover" popupId="pagination-submenu">
                  {paginationPopupState => (
                    <>
                      <MenuItem {...bindTrigger(paginationPopupState)}>
                        <PageviewOutlinedIcon sx={{ mr: 2, color: "text.secondary" }} />
                        <Typography sx={{ flexGrow: 1 }}>
                          Items per Page: {pagination.limitValue}
                        </Typography>
                      </MenuItem>
                      <Menu
                        {...bindMenu(paginationPopupState)}
                        anchorOrigin={{ vertical: "top", horizontal: "left" }}
                        transformOrigin={{ vertical: "top", horizontal: "right" }}
                        sx={{ ml: -1 }}
                      >
                        {PAGINATION_PAGES.map(limit => (
                          <MenuItem
                            key={limit}
                            onClick={() => {
                              handleLimitChange(limit);
                              paginationPopupState.close();
                            }}
                          >
                            <FormControlLabel
                              control={
                                <Radio
                                  checked={pagination.limitValue === limit}
                                  size="small"
                                />
                              }
                              label={limit}
                              sx={{ mr: 0 }}
                            />
                          </MenuItem>
                        ))}
                      </Menu>
                    </>
                  )}
                </PopupState>
              </>
            )}
          </Menu>
          {selectAllChecked && (
            <AddAssetsModal
              title={isInventoryRequest ? "Add Entire Page to Order" : "Add Entire Page to Cart"}
              assets={assets
                .filter(v => v.availableQuantity > 0)
                .map(v => ({ ...v, quantity: v.availableQuantity }))}
              onClose={() => setSelectAllChecked(false)}
              processNewItem={processNewItem}
            />
          )}
        </>
      )}
    </PopupState>
  );
}
